var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.076,
    height: 38.076,
    viewBox: "0 0 38.076 38.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information_1358014",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39838",
    "data-name": "Path 39838",
    d: "M32.5,5.576A19.038,19.038,0,0,0,5.576,32.5,19.038,19.038,0,0,0,32.5,5.576ZM2.248,19.038A16.789,16.789,0,1,1,19.037,35.827,16.808,16.808,0,0,1,2.248,19.038Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39839",
    "data-name": "Path 39839",
    d: "M201.529,68.652a4.376,4.376,0,1,0,4.376,4.376A4.381,4.381,0,0,0,201.529,68.652Zm0,6.5a2.128,2.128,0,1,1,2.128-2.128A2.13,2.13,0,0,1,201.529,75.156Zm0,0",
    transform: "translate(-182.491 -63.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39840",
    "data-name": "Path 39840",
    d: "M201.477,204.488a4.329,4.329,0,0,0-4.324,4.324v9.115a4.324,4.324,0,1,0,8.649,0v-9.115A4.329,4.329,0,0,0,201.477,204.488Zm2.076,13.439a2.076,2.076,0,1,1-4.152,0v-9.115a2.076,2.076,0,0,1,4.152,0Zm0,0",
    transform: "translate(-182.492 -189.281)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information_Icon.e46f9b26091abf61404f03eddfd10a82.svg";
export { ForwardRef as ReactComponent };